import { markRaw } from 'vue'
import $_ from '@/utils/setup/lodash'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      data () {
        return { _: markRaw($_) }
      },
    })
  },
}
